module.exports = __webpack_public_path__ + "img/empty-address-book.0d9595ac.svg";